import HeroCarousel from './components/hero-carousel';
import createHowItWorksCarousel from './components/hiw-carousel';
import createScrollableElements, { centerAlignScrollableElement, scrollOnHover } from './components/scrollable';
import createProductFeatures from './components/product-features';
import Accordion from './components/Accordion';
import ScrollToElement from './components/ScrollToElement';
import { trackEvent } from '@99designs/utils/platform';

// Hero scroll to HIW link
document.addEventListener('DOMContentLoaded', () => {
    const scrollToLinks = document.querySelectorAll('[data-hero-scrollto-link]');

    for (var i = 0; i < scrollToLinks.length; i++) {
        new ScrollToElement(scrollToLinks[i]).handleClick();
    }
});

document.addEventListener('DOMContentLoaded', () => {

    // Track FAQ usage to Segment
    const accordionTriggers = document.querySelectorAll('#faqs [data-accordion-item-trigger]');

    for (var i = 0; i < accordionTriggers.length; i++) {
        const trigger = accordionTriggers[i];

        trigger.addEventListener('click', (e) => trackEvent('Clicked FAQ on Product Page', {
            title: trigger.textContent.trim(),
        }));
    }

    // Product features
    createProductFeatures();

    // How it works
    createHowItWorksCarousel(document.querySelector('[data-hiw]'));

    // horizontally scrollable elements
    createScrollableElements();

    // Example designs
    scrollOnHover('[data-scrollable="examples"]');
    centerAlignScrollableElement('[data-scrollable="examples"]')
        .then((el) => {
            const designCards = document.querySelectorAll('[data-design-card]');

            for (var i = 0; i < designCards.length; i++) {
                designCards[i].style.visibility = 'visible';
            }
        });

    // Contest listings
    scrollOnHover('[data-scrollable="contests"]');
    centerAlignScrollableElement('[data-scrollable="contests"]');

    centerAlignScrollableElement('[data-scrollable="options"]');
    scrollOnHover('[data-scrollable="options"]');

    // Hero carousel
    HeroCarousel.create().start();

    // FAQs
    Accordion.create();
});



// WEBPACK FOOTER //
// ./js/marketing/product.js